<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="titleView" v-if="tabs == 1">
      <div class="mr">
        <el-input
          v-model="params.keyword"
          clearable
          @change="searchPurchase"
          prefix-icon="el-icon-search"
          placeholder="商品名称"
          style="width: 160px"
          size="small"
        />
        <el-button style="margin-left: 10px" type="warning" size="small"
          >搜索</el-button
        >
      </div>
      <div class="mr">
        <span style="margin-right: 10px">申请日期</span>
        <el-date-picker
          value-format="timestamp"
          @change="searchPurchase"
          v-model="dataTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          style="width: 224px"
          size="small"
        />
      </div>

      <div class="mr">
        <span style="margin-right: 10px">状态</span>
        <el-select
          v-model="params.state"
          placeholder="请选择"
          @change="searchPurchase"
          size="small"
          style="width: 120px"
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="待提交" :value="-2"></el-option>
          <el-option label="未审批" :value="1"></el-option>
          <el-option label="已通过" :value="2"></el-option>
          <el-option label="已驳回" :value="3"></el-option>
          <el-option label="采购中" :value="4"></el-option>
          <el-option label="采购完成" :value="5"></el-option>
        </el-select>
      </div>

      <div class="mr">
        <el-button @click="reset" size="small">重置</el-button>
      </div>
      <div style="text-align: right; flex: 1">
        <el-button v-if="$buttonAuthority('cangku2-caigouMendian-apply')" icon="el-icon-document" @click="addShopPurchase" size="small"
          >申请采购</el-button
        >
      </div>
    </div>

    <div class="titleView" v-if="tabs == 2">
      <div class="mr">
        <el-input
          clearable
          v-model="acceptanceParams.keyword"
          prefix-icon="el-icon-search"
          placeholder="条码/商品名称/分拨单号"
          style="width: 220px"
          @change="searchacceptancedata"
          size="small"
        />
        <el-button style="margin-left: 10px" type="warning" size="small"
          >搜索</el-button
        >
      </div>
      <div class="mr">
        <span style="margin-right: 5px">验货日期</span>
        <el-date-picker
          @change="searchacceptancedata"
          v-model="acceptancedataTime"
          value-format="timestamp"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          style="width: 224px"
          size="small"
        />
      </div>

      <div class="mr">
        <span style="margin-right: 10px">状态</span>
        <el-select
          v-model="acceptanceParams.state"
          placeholder="请选择"
          @change="searchacceptancedata"
          style="width: 130px"
          size="small"
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="已验收" :value="1"></el-option>
          <el-option label="部分验收" :value="2"></el-option>
          <el-option label="未验收" :value="3"></el-option>
        </el-select>
      </div>
      <div class="mr">
        <el-button @click="reset" size="small">重置</el-button>
      </div>
    </div>
    <div class="tabLine">
      <div
        v-if="$buttonAuthority('cangku2-caigouMendian-caigou')"
        class="tabItem"
        :class="[tabs == 1 ? 'active' : 'noactive']"
        @click="handleTabClick(1)"
      >
        采购列表
      </div>
      <el-badge :value="checkCount != 0 ? checkCount : ''" :max="99">
        <div
        v-if="$buttonAuthority('cangku2-caigouMendian-yanshou')"
          class="tabItem"
          :class="[tabs == 2 ? 'active' : 'noactive']"
          @click="handleTabClick(2)"
        >
          验收列表
        </div>
      </el-badge>
    </div>

    <div class="tableView">
      <!-- 采购列表 直接分开 会清晰点 -->
      <template v-if="tabs == 1">
        <el-table :data="purchaseData" style="width: 100%">
          <el-table-column prop="procureRequestNo" label="申请批次号">
          </el-table-column>
          <el-table-column prop="createOperationInfo.operationTime" label="申请日期">
            <template slot-scope="scope">
      {{scope.row.createOperationInfo.operationTime}}
            </template>
          </el-table-column>

          <el-table-column prop="createOperationInfo.userName" label="申请人" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row">{{
                scope.row.createOperationInfo.userName
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="procureGoods_count" label="采购数量">
							</el-table-column> -->

          <el-table-column
            prop="procureGoods_count"
            label="采购数量"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procureGoodsCount }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="remarks" label="申请备注" width="140px">
            <template slot-scope="scope">
              <span class="remark">{{ scope.row.remarks }} </span>
              <el-popover
                v-if="scope.row.remarks"
                placement="top-start"
                width="200"
                trigger="hover"
                :content="scope.row.remarks"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-view"
                ></el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.state == -2" style="color: #ffae11"
                >待提交</span
              >
              <!-- <span v-else-if="(scope.row.state==4||scope.row.state==2||scope.row.state==1&&scope.row.is_shop_confirm)" style="color: #FFAE11">待确认</span> -->
              <span v-else-if="scope.row.state == 1" style="color: #ffae11"
                >未审批</span
              >
              <span v-else-if="scope.row.state == 2" style="color: #2a2a2a"
                >已通过</span
              >
              <span v-else-if="scope.row.state == 3" style="color: #ff182a"
                >已驳回</span
              >
              <span v-else-if="scope.row.state == 4" style="color: #2a2a2a"
                >采购中</span
              >
              <span v-else-if="scope.row.state == 5" style="color: #67c23a"
                >采购完成</span
              >
            </template>
          </el-table-column>
          <el-table-column label="是否确认" width="100">
            <template slot-scope="scope">
              <span style="color: #2a2a2a">{{
                scope.row.isShopConfirm
                  ? scope.row.isShopConfirm == null
                    ? "需确认"
                    : "已确认"
                  : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="checkInfo" label="审批人" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.shopConfirm">
                {{ scope.row.shopConfirm.userName}}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="procureGoods_count" label="审批时间">
            <template slot-scope="scope">
              <span v-if="scope.row.shopConfirm">
                {{ scope.row.shopConfirm.operationTime}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.is_shop_confirm && scope.row.shop_confirm == null
                "
                @click="surePurchase(scope.row)"
                icon="el-icon-circle-check
			"
                type="text"
                size="small"
                >确认采购
              </el-button>

              <el-button
                v-if="scope.row.state == -2"
                type="text"
                size="small"
                @click="del(scope.row)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.state == -2"
                @click="editPurchase(scope.row)"
                icon="el-icon-edit"
                type="text"
                size="small"
                >编辑
              </el-button>
              <el-button
                icon="el-icon-view"
                type="text"
                @click="lookDl(scope.row.procureRequestNo)"
                size="small"
                >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="tabs == 2">
        <el-table :data="inspectionData" style="width: 100%">
          <el-table-column prop="distributionNo" label="分拨批次号">
          </el-table-column>
          <el-table-column prop="create_time" label="采购分拨日期">
            <template slot-scope="scope">
              {{ scope.row.createOperationInfo.operationTime}}
            </template>
          </el-table-column>

          <el-table-column prop="userName" label="分拨人" width="80">
            <template slot-scope="scope">
              {{ scope.row.createOperationInfo.userName}}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 1" style="color: #2a2a2a"
                >已验收</span
              >
              <span v-if="scope.row.state == 2" style="color: #ffae11"
                >部分验收</span
              >
              <span v-if="scope.row.state == 3" style="color: #ff182a"
                >未验收</span
              >
            </template>
          </el-table-column>
<!-- 
          <el-table-column prop="name" label="验收人" width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.received_goods &&
                  scope.row.received_goods.length > 0
                "
              >
                {{
                  scope.row.received_goods[scope.row.received_goods.length - 1]
                    .success_user_info.user_name
                }}</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="name" label="验收日期">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.received_goods &&
                  scope.row.received_goods.length > 0
                "
              >
                {{
                  $public.FTime(
                    scope.row.received_goods[
                      scope.row.received_goods.length - 1
                    ].received_time
                  )
                }}</span
              >
            </template>
          </el-table-column> -->
          <el-table-column prop="remarks" label="验收备注">
            <template slot-scope="scope">
              <span class="remark">{{ scope.row.remarks }} </span>
              <el-popover
                v-if="scope.row.remarks"
                placement="top-start"
                width="200"
                trigger="hover"
                :content="scope.row.remarks"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-view"
                ></el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state != 1"
                icon="el-icon-edit"
                type="text"
                @click="inspectionEdit(scope.row.distributionNo)"
                size="small"
                >验货</el-button
              >
              <el-button
                icon="el-icon-view"
                type="text"
                @click="inspectionLook(scope.row.distributionNo)"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <page
        :page="params.pageIndex"
        :total="total"
        @change="changePage"
        style="padding: 10px 0; background: #fff"
      >
      </page>
    </div>

    <el-dialog
      title="采购申请单查看"
      :visible.sync="dialogDl"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="titlecon" v-if="procureRequestDetail">
        <div class="titleleft">
          <span>申请批次号: {{ procureRequestDetail.procureRequestNo }}</span>
          <span v-if="procureRequestDetail"
            >申请日期：
            {{ procureRequestDetail.createOperationInfo.operationTime}}</span
          >
          <span
            >期望到货日期:
            {{
             procureRequestDetail.expectTime
            }}</span
          >
          <span>
            状态:
            <span v-if="procureRequestDetail.state == -2" style="color: #ffae11"
              >待提交</span
            >
            <!-- <span v-else-if="(procureRequestDetail.state==4||procureRequestDetail.state==2||procureRequestDetail.state==1&&procureRequestDetail.is_shop_confirm)"
						style="color: #FFAE11">待确认</span> -->
            <span
              v-else-if="procureRequestDetail.state == 1"
              style="color: #ffae11"
              >未审批</span
            >
            <span
              v-else-if="procureRequestDetail.state == 2"
              style="color: #2a2a2a"
              >已通过</span
            >
            <span
              v-else-if="procureRequestDetail.state == 3"
              style="color: #ff182a"
              >已驳回</span
            >
            <span
              v-else-if="procureRequestDetail.state == 4"
              style="color: #2a2a2a"
              >采购中</span
            >
            <span
              v-else-if="procureRequestDetail.state == 5"
              style="color: #67c23a"
              >采购完成</span
            >
            <el-popover
              style="margin-left: 5px"
              v-if="procureRequestDetail.state == 3"
              placement="bottom"
              width="200"
              trigger="hover"
              :content="procureRequestDetail.check_info.check_remark"
            >
              <el-button
                slot="reference"
                type="text"
                icon="el-icon-view"
              ></el-button>
            </el-popover>
          </span>
          <div>
            <span v-if="procureRequestDetail.createOperationInfo.userName"
              >申请人:{{
                procureRequestDetail.createOperationInfo.userName
              }}</span
            >
            <!-- <span v-if="procureRequestDetail.check_info"
              >审批人:{{
                procureRequestDetail.check_info.check_user_info.user_name
              }}</span
            >
            <span v-if="procureRequestDetail.check_info"
              >审批日期:{{
                $public.FTime(procureRequestDetail.check_info.check_time)
              }}</span
            > -->

            <span>产品数量: {{ procureRequestDetail.goodsCount }}</span>
            <span
              >采购数量: {{ procureRequestDetail.procureGoodsCount }}</span
            >
            <span>备注: {{ procureRequestDetail.remarks }}</span>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goodsType)">
          <div>
            {{
              item.goodsType == 1
                ? "医疗类"
                : item.goodsType == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goodsType]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>

        <el-table
          v-show="showType['showType' + item.goodsType]"
          show-summary
          :data="item.goods"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
              <el-tag
                type="success"
                style="margin-left: 10px"
                size="mini"
                v-if="scope.row.procureGoodsState == 2"
              >
                增
              </el-tag>
              <el-tag
                type="warning"
                style="margin-left: 10px"
                size="mini"
                v-if="scope.row.procureGoodsState == 4"
              >
                换
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="120px">
            <template slot-scope="scope">
              <span>{{ scope.row.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="120px">
            <template slot-scope="scope">
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="采购数量" prop="count" width="180px">
            <template slot-scope="scope">
              {{ scope.row.count }}
            </template>
          </el-table-column>
          <el-table-column label="采购状态" prop="count" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.goodsState == 1">申请中</span>
              <span v-if="scope.row.goodsState == 2">部分验货</span>
              <span v-if="scope.row.goodsState == 3">未分拨</span>
              <span v-if="scope.row.goodsState == 4">部分分拨</span>
              <span v-if="scope.row.goodsState == 5">未打码</span>
              <span v-if="scope.row.goodsState == 6">部分打码</span>
              <span v-if="scope.row.goodsState == 7">全部打码</span>
              <span v-if="scope.row.goodsState == 8">分拨出库</span>
              <span v-if="scope.row.goodsState == 9">门店部分收货</span>
              <span v-if="scope.row.goodsState == 10">门店收货</span>
              <span v-if="scope.row.goodsState == -2">无货</span>
              <span v-if="scope.row.goodsState == -3">异常</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="180px">
            <template slot-scope="scope">
              <div class="remark">
                {{ scope.row.procureGoodsRemark }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="comH2" @click="handleShopClick(3)">
        <div>修改记录</div>
        <i v-if="showType['showType' + 3]" class="el-icon-caret-bottom"></i>
        <i v-else class="el-icon-caret-top"></i>
      </div>
      <div class="updatetitle">
        <span>原商品</span>
        <span>修改商品</span>
      </div>
      <el-table
        v-show="showType['showType' + 3]"
        show-summary
        :data="procureRequestDetail.updateList"
        style="width: 100%"
        size="small"
      >
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procureGoods.title
            }}</span>
            <span v-else>{{
              scope.row.procureGoodsReplace
                ? scope.row.pprocureGoodsReplace.title
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procureGoods.brand
            }}</span>
            <span v-else>{{
              scope.row.procureGoodsReplace
                ? scope.row.pprocureGoodsReplace.brand
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procureGoods.goodsType == 1
                ? "商品类"
                : "医疗类"
            }}</span>
            <span v-else>{{
              scope.row.procureGoodsReplace
                ? scope.row.pprocureGoodsReplace.goodsType == 1
                  ? "商品类"
                  : "医疗类"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procureGoods.skuValue
            }}</span>
            <span v-else>{{
              scope.row.procureGoodsReplace
                ? scope.row.pprocureGoodsReplace.skuValue
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="采购数量" prop="count" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procureGoods.orderNum
            }}</span>
            <span v-else>{{
              scope.row.procureGoodsReplace
                ? scope.row.pprocureGoodsReplace.orderNum
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.procureGoods.deleteRemark }}</span>
          </template>
        </el-table-column>

        <el-table-column label="" width="100px">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini" v-if="scope.row.state == 0">
              删
            </el-tag>

            <el-tag type="success" size="mini" v-if="scope.row.state == 2">
              增
            </el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.state == 4">
              换
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0"
              >{{
                scope.row.procureGoodsReplace
                  ? scope.row.pprocureGoodsReplace.title
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procureGoods.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procureGoodsReplace
                  ? scope.row.pprocureGoodsReplace.brand
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procureGoods.brand }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procureGoodsReplace
                  ? scope.row.pprocureGoodsReplace.goodsType == 1
                    ? "商品类"
                    : "医疗类"
                  : ""
              }}</span
            >
            <span v-else>{{
              scope.row.procureGoods.goodsType == 1
                ? "商品类"
                : "医疗类"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procureGoodsReplace
                  ? scope.row.pprocureGoodsReplace.skuValue
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procureGoods.skuValue }}</span>
          </template>
        </el-table-column>

        <el-table-column label="采购数量" prop="count" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procureGoodsReplace
                  ? scope.row.pprocureGoodsReplace.orderNum
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procureGoods.orderNum }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="dialogDl = false" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="验货查看"
      :visible.sync="dialogaccept"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>分拨批次号: {{ inspectionDetail.distributionNo }}</span>
          <span>分拨人: {{ inspectionDetail.createOperationInfo.userName }}</span>
          <span v-if="inspectionDetail.createOperationInfo"
            >分拨人 {{ inspectionDetail.createOperationInfo.userName }}</span
          >
          <span
            >分拨时间: {{ inspectionDetail.createOperationInfo.operationTime }}</span
          >
          <span>分拨数量: {{ distributionCount }}</span>
          <span
            >状态:
            <span style="color: #2a2a2a" v-if="inspectionDetail.state == 1"
              >已验收</span
            >
            <span style="color: #ffae11" v-if="inspectionDetail.state == 2"
              >部分验收
            </span>
            <span style="color: #ff182a" v-if="inspectionDetail.state == 3"
              >未验收
            </span></span
          >
       <!-- <div>
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收人:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].success_user_info.user_name
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收时间:
              {{
                $public.FTime(
                  inspectionDetail.received_goods[
                    inspectionDetail.received_goods.length - 1
                  ].received_time
                )
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收数量:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].received_count
              }}</span
            >
  
          </div>  -->
          <div></div>
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goodsType)">
          <div>
            {{
              item.goodsType == 1
                ? "医疗类"
                : item.goodsType == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goodsType]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>
        <el-table
          row-class-name="row-expand-cove"
          :ref="'table' + item.goodsType"
          v-show="showType['showType' + item.goodsType]"
          show-summary
          :data="item.goods"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span>{{ scope.row.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格" >
            <template slot-scope="scope">
              <span>{{ scope.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" >
            <template slot-scope="scope">
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="分拨数量"
            prop="distributionCount"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.distributionCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收数量" width="100" prop="acceptanceInfo">
            <template slot-scope="scope">
              <span class="">{{ scope.row.acceptanceInfo.paidCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="200">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distributionState == 2
                "
              >
                <span style="color: #13ce66">•</span>
                已验收
              </span>
              <span v-if="scope.row.distributionState == 1">
                <span style="color: #e6a23c">•</span>
                未验收
              </span>
              <span
                v-if="
                  scope.row.acceptance_info &&
                  scope.row.acceptanceInfo.abnormalInfo &&
                  (scope.row.acceptanceInfo.abnormalInfo.leakageCount ||
                    scope.row.acceptanceInfo.abnormalInfo.overdueCount ||
                    scope.row.acceptanceInfo.abnormalInfo.brokenCount ||
                    scope.row.acceptanceInfo.abnormalInfo.switchCount)
                "
              >
                <span style="color: #ff4d51">•</span>
                异常
                {{
                  scope.row.acceptanceInfo.abnormalInfo.leakageCount +
                  scope.row.acceptanceInfo.abnormalInfo.overdueCount +
                  scope.row.acceptanceInfo.abnormalInfo.brokenCount +
                  scope.row.acceptanceInfo.abnormalInfo.switchCount
                }}
                <el-popover
                  popper-class="abnormalpopover"
                  placement="bottom"
                  trigger="click"
                >
                  <div class="abnormal">
                    <div>
                      漏发数量
                      {{
                        scope.row.acceptanceInfo.abnormalInfo.leakageCount
                      }}
                    </div>
                    <div>
                      过期数量
                      {{
                        scope.row.acceptanceInfo.abnormalInfo.overdueCount
                      }}
                    </div>
                    <div>
                      破损数量
                      {{ scope.row.acceptanceInfo.abnormalInfo.brokenCount }}
                    </div>
                    <div>
                      调换数量
                      {{ scope.row.acceptanceInfo.abnormalInfo.switchCount }}
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-view"
                  ></el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态"  width="200">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distributionState == 2
                "
              >
                <span style="color: #13ce66">•</span>
                已验收 
              </span>
              <span v-if="scope.row.acceptanceInfo.distributionState == 1">
                <span style="color: #e6a23c">•</span>
                未验收 
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProcureRequest,
  confirmProcureRequest,
  procureRequestDl,
  getShopAcceptanceList,
  // getNoCheckCount,
  getDistributionInfo,
  delProcureRequest,
} from "@/api/shopPurchaseApiNew.js";
import {
  getNoCheckCount,
} from "@/api/shopPurchaseApi.js";
import page from "../../../components/page.vue";

export default {
  components: {
    page,
  },
  data() {
    return {
      fixedHeight: "",
      tabs: 1,
      dataTime: "",
      acceptancedataTime: "",
      params: {
        checkStartTime:"",
        checkEndTime:"",
        pageIndex: 1,
        pageSize: 10,
        keyword: "",
        shopId: this.$store.getters.curShopInfo.shop_id,
        startTime: "",
        endTime: "",
        state: 0,
        isShopConfirm:-1, //门店是否确认 -1 全部 1 是 2 否
      },
      total: 0,
      purchaseData: [],
      dialogDl: false,
      procureRequestDetail: "",
      sumData: [],
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
        showType3: true,
      },
      acceptanceParams: {
        pageIndex: 1,
        pageSize: 10,
        keyword: "",
        state: -1,
        shopId: this.$store.getters.curShopInfo.shop_id,
        startTime: "",
        endTime: "",
      },
      inspectionData: [],
      checkCount: 0,
      dialogaccept: false,
      inspectionDetail: "",
    };
  },
  computed: {
    //计算分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.distributionGoods.forEach((item) => {
        distributionCount += item.distributionCount;
      });
      return distributionCount;
    },
  },
  methods: {
    //删除待提交的申请单
    del(row) {
      this.$confirm("此操作将删除该申请单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            procureRequestNo: row.procureRequestNo,
          };
          delProcureRequest(params).then((res) => {
            if (res.code == 0) {
              this.getProcureRequest();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    searchPurchase() {
      this.params.pageIndex = 1;
      this.params.startTime =
        this.dataTime && this.dataTime[0].toString().length > 10
          ? this.$public.FTime(this.dataTime[0].toString().substr(0, 10))
          : "";
      this.params.endTime =
        this.dataTime && this.dataTime[1].toString().length > 10
          ? this.$public.FTime(this.dataTime[1].toString().substr(0, 10))
          : "";
      this.getProcureRequest();
    },
    searchacceptancedata() {
      this.acceptanceParams.pageIndex = 1;
      this.acceptanceParams.startTime =this.acceptancedataTime &&this.acceptancedataTime[0].toString().length > 10
          ? this.$public.FTime(this.acceptancedataTime[0].toString().substr(0, 10))
          : "";
      this.acceptanceParams.endTime =
        this.acceptancedataTime &&
        this.acceptancedataTime[1].toString().length > 10
          ? this.$public.FTime(this.acceptancedataTime[1].toString().substr(0, 10))
          : "";
      this.getShopAcceptanceList();
    },
    //改变页数
    changePage(val) {
      if (this.tabs == 1) {
        this.params.pageIndex = val;
        this.getProcureRequest();
      } else {
        this.acceptanceParams.pageIndex = val;
        this.getShopAcceptanceList();
      }
    },

    //切换tab按钮
    handleTabClick(tab) {
      this.tabs = tab;
      if (tab == 1) {
        this.getProcureRequest();
      } else {
        this.getShopAcceptanceList();
      }
    },
    getProcureRequest() {
      getProcureRequest(this.params).then((res) => {
        if (res.code == 0) {
          this.total = res.data.count;

          this.purchaseData = res.data.list;
        }
      });
    },
    getShopAcceptanceList() {
      getShopAcceptanceList(this.acceptanceParams).then((res) => {
        if (res.code == 0) {
          this.total = res.data.count;
          this.inspectionData = res.data.list;
        }
      });
    },
    addShopPurchase() {
      this.$router.push({
        path: "/caigouMendianNew/shopPurchaseEdit",
      });
    },
    inspectionEdit(id) {
      this.$router.push({
        path: "/caigouMendianNew/inspectionEdit",
        query: {
          id,
        },
      });
    },
    inspectionLook(id) {
      this.dialogaccept = true;
      let inspectionDetail=[]
      getDistributionInfo({
        distributionNo: id,
      }).then((res) => {
      
        if (res.code == 0) {
          console.log(res,'res11111ss');
         inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.distributionGoods);
          console.log(this.sumData, inspectionDetail,'0000');
          this.inspectionDetail=inspectionDetail
        }
      });
      
    },
    editPurchase(row) {
      // console.log(row)
      this.$router.push({
        path: "/caigouMendianNew/shopPurchaseEdit",
        query: {
          procureRequestNo: row.procureRequestNo,
        },
      });
    },
    surePurchase(row) {
      this.$confirm("确认采购员提出的改动？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmProcureRequest({
            procureRequestNo: row.procureRequestNo,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "确认成功!",
              });
              this.getProcureRequest();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    lookDl(procureRequestNo) {
      this.dialogDl = true;
      procureRequestDl({
        procureRequestNo,
      }).then((res) => {
        if (res.code == 0) {
          console.log("1111", res.data);
          this.procureRequestDetail = res.data;
          let procureGoodsList = res.data.procureGoodsList.filter(
           
            (item) => {
              console.log(item,"item")
              return (
                item.procureGoodsState != 0 && item.procureGoodsState != 0
              );
            }
          );
          this.procureRequestDetail.procureGoodsList = procureGoodsList;
          this.sumData = this.sumGoods(procureGoodsList);
          console.log(this.sumData,'this.sumData');
        }
      });
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },

    sumGoods(arry) {
      let sumData = [];
      arry.forEach((item) => {
        console.log(item,"item");
        let index = sumData.findIndex((ele) => {
          console.log(ele,'ele');
          return item.goodsType == ele.goodsType;
        });
        if (index == -1) {
          sumData.push({
            goodsType: item.goodsType,
            goods: [item],
          });
        } else {
          sumData[index].goods.push(item);
        }
      });
      return sumData;
    },
    getNoCheckCount() {
      getNoCheckCount({
        shopId: this.$store.getters.curShopInfo.shopId,
      }).then((res) => {
        if (res.code == 0) {
          this.checkCount = res.data;
        }
      });
    },
    reset() {
      if (this.tabs == 1) {
        this.dataTime = "";
        this.params = {
          pageIndex: 1,
          pageSize: 10,
          keyword: "",
          shopId: this.$store.getters.curShopInfo.shopId,
          startTime: "",
          endTime: "",
          state: 0,
        };
        this.getProcureRequest();
      } else {
        this.acceptancedataTime = "";
        this.acceptanceParams = {
          pageIndex: 1,
          pageSize: 10,
          keyword: "",
          state: -1,
          shopId: this.$store.getters.curShopInfo.shopId,
          startTime: "",
          endTime: "",
        };
        this.getShopAcceptanceList();
      }
    },
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goodsState == 4;
      });

      return custtomList;
    },
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    this.getNoCheckCount();
    if (
      this.$route.query.tabs ||
      !this.$buttonAuthority('cangku-caigouMendian-caigou')
    ) {
      this.tabs = 2;
      this.getShopAcceptanceList();
    } else {
      this.tabs = 1;
      this.getProcureRequest();
    }
  },
};
</script>

<style scoped="scoped" lang="scss">
.page {
  display: flex;
  flex-direction: column;
  .tabLine {
    display: flex;
    margin: 10px 0;

    .tabItem {
      width: 100px;
      box-sizing: border-box;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .titleView {
    background: #fff;
    height: 72px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 14px;
  }

  .mr {
    margin-right: 10px;
  }

  .comH2 {
    line-height: 64px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .tabView {
    margin: 20px 0;
  }

  .tableView {
    flex: 1;
    background: #fff;
  }
  .active {
    background: #f5882a;
    color: #fff;
  }

  .noactive {
    background: #fff;
    color: #000;
  }

  .titlecon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
    background-color: #f5f5f5;
    padding: 5px 0;
    border-radius: 5px;

    .titleleft {
      span {
        margin: 5px 20px;
        display: inline-block;
      }
    }

    .titleright {
      width: 300px;
      // margin-top: 20px;
    }
  }

  .updatetitle {
    display: flex;
    justify-content: space-around;
    height: 47px;
    line-height: 47px;
    background-color: #f5f5f5;
  }

  .remark {
    display: inline-block;
    width: 80px;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
